import { render, staticRenderFns } from "./TaxReturnInvoicesTable.vue?vue&type=template&id=080d70a3&scoped=true"
import script from "./TaxReturnInvoicesTable.vue?vue&type=script&lang=js"
export * from "./TaxReturnInvoicesTable.vue?vue&type=script&lang=js"
import style0 from "./TaxReturnInvoicesTable.vue?vue&type=style&index=0&id=080d70a3&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080d70a3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('080d70a3')) {
      api.createRecord('080d70a3', component.options)
    } else {
      api.reload('080d70a3', component.options)
    }
    module.hot.accept("./TaxReturnInvoicesTable.vue?vue&type=template&id=080d70a3&scoped=true", function () {
      api.rerender('080d70a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/components/TaxReturnInvoicesTable.vue"
export default component.exports